export const GT_SIGNUP_CONTINUATION_KEY = "gt_signup_continuation";
export const GT_SIGNUP_UPLOAD_TOKEN_KEY = "gt_signup_upload_token";
export const GT_SIGNUP_COMPANY_ID_KEY = "gt_signup_company_id";
export const GT_SIGNUP_META_KEY = "gt_signup_registration_meta";

export type SignupRegistrationMeta = {
  companyName: string;
  email: string;
  headquartersCity: string;
  headquartersCountry: string;
};

export function clearSignupFlowStorage() {
  sessionStorage.removeItem(GT_SIGNUP_CONTINUATION_KEY);
  sessionStorage.removeItem(GT_SIGNUP_UPLOAD_TOKEN_KEY);
  sessionStorage.removeItem(GT_SIGNUP_COMPANY_ID_KEY);
  sessionStorage.removeItem(GT_SIGNUP_META_KEY);
}
